var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FilePdf",
    clipPath: "url(#clip0_1588_5411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.8125 27.3125H33.0625V37.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.375 33.0625H33.0625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.625 34.5H11.5C12.4531 34.5 13.3672 34.1214 14.0412 33.4474C14.7151 32.7735 15.0938 31.8594 15.0938 30.9062C15.0938 29.9531 14.7151 29.039 14.0412 28.3651C13.3672 27.6911 12.4531 27.3125 11.5 27.3125H8.625V37.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.125 27.3125V37.375H23C24.3344 37.375 25.6141 36.8449 26.5576 35.9014C27.5012 34.9578 28.0312 33.6781 28.0312 32.3438C28.0312 31.0094 27.5012 29.7297 26.5576 28.7861C25.6141 27.8426 24.3344 27.3125 23 27.3125H20.125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.625 20.125V7.1875C8.625 6.80625 8.77645 6.44062 9.04603 6.17103C9.31562 5.90145 9.68125 5.75 10.0625 5.75H27.3125L37.375 15.8125V20.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.3125 5.75V15.8125H37.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_5411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFileIcon);
export default __webpack_public_path__ + "static/media/pdfFileIcon.fd97148bea355997591d84695b81beb6.svg";
export { ForwardRef as ReactComponent };